import api from 'utils/apiClient';

export const loadPaidServices = (params) => {
  return api.get(`/market_services`, {
    params,
  })
}

export const createPaidService = (data) => {
  return api.post('/market_services', data)
}

export const editPaidService = ({id, ...data}) => {
  return api.patch(`/market_services/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
  })
}